import React from 'react';
// import strapiDb from '../../data/strapi_db.json';
import strapiDb from '../../../data/strapi_db.json';
import LeftIcon from './LeftIcon/index';
import RightIcon from './RightIcon/index';

export default function ConditionalTopStrip({ campaign, leftIcon, rightIcon }) {
  const { count } = strapiDb?.seatsLeft || { count: 150 };

  const getTopStrip = () => {
    switch (campaign) {
      case 'timer':
        return (
          <div class=" my-2 flex w-full flex-col items-center justify-center text-center md:flex-row">
            <div className="flex flex-col items-center gap-2 text-center md:flex-row md:gap-6">
              <p>
                Unlock the <strong>prime years</strong> of your{' '}
                <strong>tech career</strong> & avail{' '}
                <br className="md:hidden" /> scholarships of up to{' '}
                <strong>₹1,20,000</strong> | <strong>{count} Seats</strong>{' '}
                |&nbsp;
                <strong className="underline">Apply Now</strong>
              </p>

              <img
                src="https://s.mmgo.io/t/CzPZ/"
                alt="motionmailapp.com"
                className="w-[200px] md:w-[250px]"
              />
            </div>
          </div>
        );
      case 'topStripWithSeats':
        return (
          <div class=" w-full text-center ">
            <div className="text-center">
              Unlock the <strong>prime years</strong> of your{' '}
              <strong>tech career</strong> & avail <br className="md:hidden" />{' '}
              scholarships of up to <strong>₹1,20,000</strong> |{' '}
              <strong>{count} Seats</strong> |&nbsp;
              <strong className="underline">Apply Now</strong>
            </div>
          </div>
        );
      case 'independenceDay':
        return (
          <div class="flex w-full flex-col items-center justify-center gap-[6px] py-[9px] px-5 text-center md:flex-row md:gap-[18px]">
            <div className="text-center font-normal">
              Unlock Your Dream Tech Career This{' '}
              <span className="font-extrabold">Independence Day</span> | Get
              benefits up to <span className="font-extrabold">₹1,50,000</span> |
              &nbsp;
              <span className="font-extrabold">{count} Seats Left</span> |
              &nbsp;
              <strong className="font-extrabold text-v5-yellow-200">
                Apply Now
              </strong>
            </div>
            <img
              src="https://s.mmgo.io/t/Czgu/"
              alt="motionmailapp.com"
              className="w-[150px] md:w-[185px]"
            />
          </div>
        );
      default:
        return (
          <div class=" w-full text-center ">
            <div className="text-center">
              Transform your career with Crio.Do | Grab{' '}
              <br className="block md:hidden" /> scholarships worth{' '}
              <strong>₹60,000</strong> |&nbsp;
              <strong className="underline">Apply Now</strong>
            </div>
          </div>
        );
    }
  };

  const getContainerClassName = () => {
    switch (campaign) {
      case 'independenceDay':
        return 'flex md:min-h-[50px] min-h-[81px] w-screen cursor-pointer items-center justify-between top-strip-independence-day font-manrope text-[12px] text-white md:items-center md:justify-between md:gap-6 md:px-0 md:py-0 md:text-center md:text-[18px]';
      default:
        return 'flex min-h-[44px] w-screen cursor-pointer items-center justify-between bg-[#2DF8C5] pl-4 font-rubik text-[12px] text-[#013437] md:items-center md:justify-between md:gap-6 md:px-0 md:py-0 md:text-center md:text-[18px]';
    }
  };
  return (
    <div className={getContainerClassName()}>
      {leftIcon ? <LeftIcon /> : <></>}
      {getTopStrip()}
      {rightIcon ? <RightIcon /> : <></>}
    </div>
  );
}
